/**
 * For Google Tag Manager
 */
let dataLayer: typeof window.dataLayer = [];
if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || dataLayer;
    dataLayer = window.dataLayer;
}
export default dataLayer;
